import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Shared open/closed state for the Control Panel map view.
 *
 * The toggle control lives in the mobile bottom navigation (DashboardLayout)
 * while the map itself renders on the Pours page — two separate component
 * trees — so the state is lifted here rather than held locally.
 */
interface MapViewContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

const MapViewContext = createContext<MapViewContextValue>({
  open: false,
  setOpen: () => {},
  toggle: () => {},
});

export const MapViewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((o) => !o), []);
  return (
    <MapViewContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </MapViewContext.Provider>
  );
};

export const useMapView = (): MapViewContextValue => useContext(MapViewContext);
